import { MessageService } from 'primeng/api';
import { Component, Input, OnChanges } from '@angular/core';
import { SearchService } from '@modules/search/services/search.service';
import { EmlViewComponent } from '../eml-view/eml-view.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ActionsService } from '@modules/search/services/actions.service';
import { DocLoaderComponent } from '../doc-loader/doc-loader.component';
import { ImageModule } from 'primeng/image';
import { AuthService } from '@core/services/auth/auth.service';
@Component({
  selector: 'app-doc-viewer',
  standalone: true,
  imports: [EmlViewComponent, DocLoaderComponent, ImageModule],
  templateUrl: './doc-viewer.component.html',
  styleUrl: './doc-viewer.component.scss',
})
export class DocViewerComponent implements OnChanges {
  @Input() filePath: string = '';
  @Input() data: any;
  @Input() isFilePreview: boolean = false;
  viewData: any;
  fileType: string = '';
  timerRef: any;
  subscription: any[] = [];

  constructor(
    private MessageService: MessageService,
    private _search: SearchService,
    private domSanitizer: DomSanitizer,
    private _auth: AuthService
  ) {}

  officeToHtmlExt = [
    'xls',
    'xlsx',
    'xlsm',
    'xlsb',
    'xlt',
    'xltx',
    'xltm',
    'ods',
    'csv',
    'doc',
    'docx',
    'docm',
    'dot',
    'dotx',
    'dotm',
    'odt',
    'rtf',
    'txt',
    'html',
    'htm',
    'ppt',
    'pptx',
    'pptm',
    'pps',
    'ppsx',
    'ppsm',
    'pot',
    'potx',
    'potm',
    'odp',
  ];
  ngOnChanges(): void {
    if (this.filePath) {
      this.getFileView(this.filePath);
      this.markDocumentAsViewed();
    }
  }

  ngOnDestroy() {
    clearTimeout(this.timerRef);
    this.subscription.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  getFileView = (filePath: string) => {
    let ext = filePath.split('.').pop()?.toLocaleLowerCase();
    if (ext === 'pdf') {
      this.fileType = 'pdf';
      this.getPDFFileToView(filePath);
    } else if (this.officeToHtmlExt.includes(ext as string)) {
      this.fileType = 'doc';
      this.getOfficeToHtml(filePath);
    } else if (
      ext === 'jpeg' ||
      ext === 'jpg' ||
      ext === 'png' ||
      ext === 'gif'
    ) {
      this.fileType = 'image';
      this.getImageToView(filePath);
    } else {
      this.downloadAttachment(filePath);
      this.MessageService.add({
        severity: 'info',
        summary: 'Unsupported File',
        detail: 'File type not supported',
        key: 'tr',
      });
      this._search.selectedDocumentSubject.next(null);
    }
  };

  isLoading: boolean = false;

  getPDFFileToView = (filePath: string) => {
    let params = {
      filePath: filePath,
    };
    this.isLoading = true;
    this._search.getPDFToView(params).subscribe({
      next: (res: any) => {
        let blob = new Blob([res], { type: 'application/pdf' });
        this.viewData = this.domSanitizer.bypassSecurityTrustResourceUrl(
          window.URL.createObjectURL(blob) + '#view=FitW'
        );
        this.isLoading = false;
      },
      error: (err: any) => {
        console.log('err', err);
        this.isLoading = false;
        this._search.selectedDocumentSubject.next(null);
        this._search.activeIndex = 0;
        if (this.isFilePreview) {
          setTimeout(() => {
            window.close();
          }, 1500);
        }
        this.MessageService.add({
          severity: 'warn',
          summary: 'Something went wrong',
          detail: 'Please try again later',
          key: 'tr',
        });
      },
    });
  };

  getOfficeToHtml = (filePath: string) => {
    let params = {
      filePath: filePath,
    };
    this.isLoading = true;
    this._search.getOfficeToHtml(params).subscribe({
      next: (res: any) => {
        this.viewData = res;
        this.isLoading = false;
      },
      error: (err: any) => {
        console.log('err', err);
        this.isLoading = false;
        this._search.selectedDocumentSubject.next(null);
        this._search.activeIndex = 0;
        if (this.isFilePreview) {
          setTimeout(() => {
            window.close();
          }, 1500);
        }
        this.MessageService.add({
          severity: 'warn',
          summary: 'Something went wrong',
          detail: 'Please try again later',
          key: 'tr',
        });
      },
    });
  };

  getImageToView = (filePath: string) => {
    let params = {
      filePath: filePath,
    };
    this.isLoading = true;
    this._search.downloadDocFile(params).subscribe({
      next: (res: any) => {
        let blob = new Blob([res], { type: 'image/jpeg' });
        this.viewData = this.domSanitizer.bypassSecurityTrustResourceUrl(
          window.URL.createObjectURL(blob)
        );
        this.isLoading = false;
      },
      error: (err: any) => {
        console.log('err', err);
        this.isLoading = false;
        this._search.selectedDocumentSubject.next(null);
        this._search.activeIndex = 0;
        if (this.isFilePreview) {
          setTimeout(() => {
            window.close();
          }, 1500);
        }
        this.MessageService.add({
          severity: 'warn',
          summary: 'Something went wrong',
          detail: 'Please try again later',
          key: 'tr',
        });
      },
    });
  };

  downloadAttachment(filePath: string) {
    let filepath = filePath;
    let param = {
      filePath: filepath,
    };
    this._search.downloadDocFile(param).subscribe({
      next: (response) => {
        let blob = new Blob([response], { type: 'application/octet-stream' });
        let url = window.URL.createObjectURL(blob);
        let a: any = document.createElement('a');
        a.href = url;
        a.download = filePath.split('/').pop();
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.log(error);
        this._search.selectedDocumentSubject.next(null);
        this._search.activeIndex = 0;
        if (this.isFilePreview) {
          setTimeout(() => {
            window.close();
          }, 1500);
        }
        this.MessageService.add({
          severity: 'warn',
          summary: 'Something went wrong',
          detail: 'Error while downloading file',
          key: 'tr',
        });
      },
    });
  }

  markDocumentAsViewed() {
    this.timerRef = setTimeout(() => {
      this.subscription[1] = this._search
        .markEmailAsRead({
          id: this.data._id,
          index: this.data._index,
        })
        .subscribe({
          next: (res) => {
            if (!this._auth.userDetail().email) {
              this._auth.getUserDetails().subscribe({
                next: (res) => {
                  this.data._source['readHistory'] = {
                    ...this.data._source['readHistory'],
                    [res.email]: [],
                  };
                },
                error: (err) => {
                  console.log(err);
                },
              });
            } else {
              this.data._source['readHistory'] = {
                ...this.data._source['readHistory'],
                [this._auth.userDetail().email]: [],
              };
            }
          },
          error: (err) => {
            console.log(err);
          },
        });
    }, 10000);
  }
}
